import { Typography } from '@mui/material'
import { localStorageItemKeys } from '~constants/local-storage-items'
import { WarningRibbon } from './warning-ribbon'

const EarningsValidationRibbon = () => {
  const validating = localStorage.getItem(
    localStorageItemKeys.earningsValidation,
  )

  if (!validating) {
    return null
  }

  const handleStopValidating = () => {
    localStorage.removeItem(localStorageItemKeys.earningsValidation)
    window.location.reload()
  }

  return (
    <WarningRibbon
      message={
        <>
          You have engaged{' '}
          <Typography variant="paragraphBold1">Earnings validation</Typography>
        </>
      }
      buttonLabel="Stop Validating"
      onButtonClick={handleStopValidating}
    />
  )
}

export default EarningsValidationRibbon
